import React, {FC, useState} from 'react';
import './style.scss';
import CardBrands from "../CardBrands";
import {useHistory} from 'react-router-dom';
import SearchPanel from "../SearchPanel";

interface ICatalogBrands {
    brands: Array<object>,
    tastesID: Array<number>
}

const CatalogBrands: FC<ICatalogBrands> = ({brands, tastesID}) => {
    const history = useHistory();
    const [value, setValue] = useState<string>('');

    const clickHandler = (id: number) => {
        history.push(`/mixer/brands/${id}`)
    };

    return (
        <div className="catalog-brands">
            <div className="catalog-brands__container">
                <div className="catalog-brands__search-panel">
                    <SearchPanel
                        tobaccoCount={tastesID.length}
                        value={value}
                        setValue={setValue}
                    />
                </div>
                <div>
                    {
                        brands
                            .filter((item: any) => item.name.toLowerCase().includes(value.toLowerCase()))
                            .map((item: any) => {
                                return (
                                    <CardBrands
                                        key={item.id}
                                        imageUrl={item.imageUrl}
                                        name={item.name}
                                        onClick={() => clickHandler(item.id)}
                                        tobaccoCount={item.tobaccoCount}
                                    />
                                )
                            })
                    }
                </div>
            </div>
        </div>
    )
};

export default CatalogBrands;
